import React from 'react'
import classNames from 'classnames'

import './Loader.scss'

/**
 * @import import { Loader } from '@/components/loaders/Loader'
 * @param {object} props
 * @param {'small'|'large'} [props.size] Spinner size; omit for the default
 * @param {boolean} [props.centered] Centers the spinner horizontally in its container
 * @param {node} [props.label] Text rendered below the spinner
 * @param {boolean} [props.page] Centers the loader in the viewport for full-page loading states
 * @param {string} [props.className] Additional classes on the spinner element
 */
export const Loader = ({ size, centered, label, page, className, ...props }) => {
  const spinner = (
    <div
      className={classNames(
        'balto-loader',
        { small: size === 'small', large: size === 'large', centered },
        className
      )}
      {...props}
    />
  )

  const content = label ? (
    <div className="balto-loader-group">
      {spinner}
      <span className="balto-loader-label">{label}</span>
    </div>
  ) : (
    spinner
  )

  if (page) {
    return <div className="balto-loader-page">{content}</div>
  }

  return content
}
